import { Link } from "react-router";

import { GUIDE_ARTICLES } from "./articles";

export function GuideIndex() {
  return (
    <article className="mx-auto w-full max-w-4xl space-y-6 p-6">
      <header className="space-y-2">
        <h1 className="text-2xl font-semibold text-text-primary">Guide</h1>
        <p className="text-sm text-text-secondary">
          Reference articles for how Rarion's selection process works — what each artefact is, what
          the scores mean, and what the workflow actions actually do.
        </p>
      </header>
      <ul className="grid grid-cols-1 gap-3 md:grid-cols-2">
        {GUIDE_ARTICLES.map((article) => (
          <li key={article.slug}>
            <Link
              to={`/help/${article.slug}`}
              className="block h-full rounded-md border border-border p-4 transition-colors hover:bg-card-hover"
            >
              <h2 className="text-base font-medium text-text-primary">{article.title}</h2>
              <p className="mt-1 text-sm text-text-secondary">{article.hook}</p>
            </Link>
          </li>
        ))}
      </ul>
    </article>
  );
}
